// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".driver-location-not-connected[data-v-8b8fce5a]{position:absolute;z-index:200;top:0}.driver-location-not-connected-style[data-v-8b8fce5a]{width:100%;height:56px;display:flex;padding:12px;justify-content:space-between;align-items:center;background:#fff5eb}span[data-v-8b8fce5a]{font-family:OpenSans;font-size:12px;padding:0 3px 0 8px}.close[data-v-8b8fce5a]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
